import { getCurrentProfileSelect } from '../get-current'
import { createSelector } from 'reselect'
import { getValueReduxUtil } from '../../../../redux/utils'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export const getGoalProfileSelect = createSelector(
  getCurrentProfileSelect,
  (profile) => (
    getValueReduxUtil(profile, PROFILE_KEY.GOAL)
  )
)
